<template>
  <router-view></router-view>
</template>


<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
}
.c-main, .container-fluid {
  padding: 0 !important;
}
</style>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
